/**
 * Synthetic step identifiers.
 *
 * Steps that have not yet been persisted to the backend have no `smid`. The UI still needs a stable
 * identifier to drive rename/delete/reorder, so it falls back to an index-based id of the form
 * `__index_<n>`. These helpers centralize that convention so generation and parsing stay in sync.
 */

const TEMP_STEP_ID_PREFIX = '__index_';
const TEMP_STEP_ID_PATTERN = /^__index_(\d+)$/;

/** Builds a synthetic step id from a step's array index (used when the step has no backend smid). */
export function generateTempStepId(index: number): string {
  return `${TEMP_STEP_ID_PREFIX}${index}`;
}

/** True when `stepId` is a synthetic index-based id rather than a real backend smid. */
export function isTempStepId(stepId: string): boolean {
  return TEMP_STEP_ID_PATTERN.test(stepId);
}

/** Extracts the array index from a synthetic step id, or `null` when `stepId` is not one. */
export function parseTempStepId(stepId: string): number | null {
  const match = stepId.match(TEMP_STEP_ID_PATTERN);
  return match ? parseInt(match[1], 10) : null;
}
